import { render } from "./ConsumptionModeDetails.vue?vue&type=template&id=23d71f14&scoped=true"
import script from "./ConsumptionModeDetails.vue?vue&type=script&lang=js"
export * from "./ConsumptionModeDetails.vue?vue&type=script&lang=js"

import "./ConsumptionModeDetails.vue?vue&type=style&index=0&id=23d71f14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d71f14"]])

export default __exports__